import { useState } from 'react'
import { useMaintenance } from '@/context/MaintenanceContext'
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa'
import './MaintenancePage.css'

const MaintenanceBypass = ({ onSuccess }) => {
  const { verifyBypass } = useMaintenance()
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!password.trim()) {
      setError('Please enter a password')
      return
    }

    setIsLoading(true)

    try {
      const result = await verifyBypass(password)

      if (result.success) {
        setPassword('')
        if (onSuccess) {
          onSuccess()
        }
        window.location.reload()
      } else {
        setError(result.error || 'Invalid password. Please try again.')
        setPassword('')
      }
    } catch (err) {
      setError('An error occurred. Please try again.')
      setPassword('')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='maintenance-bypass'>
      <div className='maintenance-bypass-header'>
        <div className='maintenance-bypass-icon-wrapper'>
          <FaLock className='maintenance-bypass-icon' />
        </div>
        <h2 className='maintenance-bypass-title'>Admin Access</h2>
        <p className='maintenance-bypass-subtitle'>
          Enter the maintenance bypass password
        </p>
      </div>

      <form onSubmit={handleSubmit} className='maintenance-bypass-form'>
        <div className='maintenance-bypass-input-group'>
          <div className='maintenance-bypass-input-wrapper'>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                setError('')
              }}
              placeholder='Enter password'
              className={`maintenance-bypass-input ${
                error ? 'maintenance-bypass-input-error' : ''
              }`}
              disabled={isLoading}
              autoFocus
            />
            <button
              type='button'
              onClick={() => setShowPassword(!showPassword)}
              className='maintenance-bypass-toggle'
              disabled={isLoading}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          {error && (
            <div className='maintenance-bypass-error' role='alert'>
              {error}
            </div>
          )}
        </div>

        <button
          type='submit'
          className='maintenance-bypass-submit'
          disabled={isLoading || !password.trim()}
        >
          {isLoading ? (
            <>
              <span className='maintenance-spinner'></span>
              Verifying...
            </>
          ) : (
            'Access Site'
          )}
        </button>
      </form>
    </div>
  )
}

export default MaintenanceBypass
